import { render } from "./profile-message-page.vue?vue&type=template&id=861ea6ce&scoped=true&ts=true"
import script from "./profile-message-page.vue?vue&type=script&lang=ts"
export * from "./profile-message-page.vue?vue&type=script&lang=ts"

import "./profile-message-page.vue?vue&type=style&index=0&id=861ea6ce&lang=less&scoped=true"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-861ea6ce"]])

export default __exports__